import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { FunctionsService } from '../services/functions.service';
import { HttpClient } from '@angular/common/http';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OkModalComponent } from '../generic-components/ok-modal/ok-modal.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-media-component',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.css'],
  providers: [NgxSpinnerService]
})

export class MediaComponent implements OnInit {
  modalOptions: NgbModalOptions = {};
  compositionSid:any;
  mediaLink:any;
  alertId:any;
  language = localStorage.getItem('language')?localStorage.getItem('language'):'en';

  constructor(
    private activatedRoute:ActivatedRoute,
    private apiService: ApiService,
    public functionsService: FunctionsService,
    private spinner:NgxSpinnerService,
    private httpClient: HttpClient,
    private modalService: NgbModal,
    private translate: TranslateService
    ) { 
      this.activatedRoute.params.subscribe(params => {
        this.alertId = params['alertId'];
        this.compositionSid = params['compositionId'];
      });
      this.translate.setDefaultLang(this.language);
      this.functionsService.setTitle('recorded_video_call');
      translate.setDefaultLang('en');
    }

  ngOnInit() {
    this.spinner.show();
    if(localStorage.getItem('language') != null){
      this.functionsService.useLanguage(localStorage.getItem('language'));
    }else{ //If the language is not specified, use default one.
        this.functionsService.useLanguage('en');
    }
    this.apiService.getAlertMedia(this.alertId, this.compositionSid).subscribe(
      data => {
        this.spinner.hide();
        if(!data){
          this.modalOptions.backdrop = 'static';
            this.modalOptions.keyboard = false;
            this.modalOptions.size = 'lg';
            var modalRef = this.modalService.open(OkModalComponent, this.modalOptions);
            modalRef.componentInstance.title = this.translate.instant('Error');
            modalRef.componentInstance.message = this.translate.instant('error.media_error');

            modalRef.result.then(() => {
                this.modalService.dismissAll();
            });
        }
      },
      error => {
        if(error["status"]==200)
        {this.mediaLink = error["error"]["text"];}
        
        else if(error["error"]["content"]=="The remote server returned an error: (404) NOT FOUND."){
          this.modalOptions.backdrop = 'static';
          this.modalOptions.keyboard = false;
          this.modalOptions.size = 'lg';
          var modalRef = this.modalService.open(OkModalComponent, this.modalOptions);
          modalRef.componentInstance.title = this.translate.instant('Error');
          modalRef.componentInstance.message = this.translate.instant('error.media_error');

          modalRef.result.then(() => {
              this.modalService.dismissAll();
          });  
        }
        else{
          this.functionsService.errorHandler(error["status"]);
        }
        this.spinner.hide();
      }
    );
  }
}


